import Vue from 'vue'
import VueRouter from 'vue-router'
import Axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import {VeTable, VePagination, VeLoading, VeIcon} from "vue-easytable";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import dotenv from 'dotenv';
import VueI18n from 'vue-i18n';
import messages from './i18n';
import VeeValidate from 'vee-validate';
import * as validatorExtensions from "./utils/vee-validate-extensions";
import {Service} from 'axios-middleware';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'simplemde/dist/simplemde.min.css'
// plugins css
import "vue-easytable/libs/theme-default/index.css";
import 'vue2-datepicker/index.css';
import VueToastr from "vue-toastr";
import 'flag-icon-css/css/flag-icon.css';

// import url('https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css');
// import url('https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.3.0/css/flag-icon.min.css');
// import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700');
import 'admin-lte/plugins/fontawesome-free/css/all.min.css';
import 'admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css';
import 'admin-lte/dist/css/adminlte.min.css';
// import 'vue-toastification/dist/index.css';

import 'vue-multiselect/dist/vue-multiselect.min.css';
import '../static/adminLte/css/adminlte.min.css';
import '../static/custom.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
import { faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
library.add(faExternalLinkSquareAlt)

dotenv.config();

Vue.use(VueRouter);
Vue.use(VeTable);
Vue.use(VePagination);
Vue.use(VeLoading);
Vue.use(VeIcon);
Vue.use(VueToastr, {});
Vue.use(VueI18n);
Vue.use(VeeValidate, { inject: true, fieldsBagName: 'veeFields', errorBagName: "veeErrors" });

const i18n = new VueI18n({
    locale: 'en',
    messages,
})

const token = localStorage.getItem('token');

Vue.config.productionTip = false;

Axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

const refreshAuthLogic = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');

    delete Axios.defaults.headers.common['Authorization'];

    window.location.reload();
};

createAuthRefreshInterceptor(Axios, refreshAuthLogic);

const service = new Service(Axios);
service.register({
    onRequest(config) {
        localStorage.setItem('lastActiveAt', Date.now().toString());
        return config;
    }
});

setInterval(() => {
    if (router.currentRoute.name === 'Login') {
        return;
    }
    let lastActiveAt = localStorage.getItem('lastActiveAt');

    if (!lastActiveAt) {
        return;
    }

    let idleSeconds = (Date.now() - Number.parseInt(lastActiveAt)) / 1000;

    let maxIdleSeconds = 20 * 60;

    if (idleSeconds > maxIdleSeconds) {
        localStorage.removeItem('lastActiveAt');
        refreshAuthLogic();
    }
}, 1000);

Vue.prototype.$http = Axios;

if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

if (process.env.VUE_APP_DOCUMENT_TITLE) {
    document.title = process.env.VUE_APP_DOCUMENT_TITLE;
}

Vue.prototype.$veLoading = VeLoading;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    created() {
        this.$validator.extend('maxDimensions', validatorExtensions.maxDimensionsRule);
        this.$validator.extend('maxWidthHeightRatio', validatorExtensions.maxWidthHeightRatioRule);
        this.$validator.extend('mustSetIsLeftForGameTypes', validatorExtensions.mustSetIsLeftForGameTypesRule);
        this.$validator.extend('minTrimmedLength', validatorExtensions.minTrimmedLengthRule);
    },
    mounted() {
        this.$store.dispatch('loadApplicationData');
        this.$toastr.defaultPosition = "toast-top-right";
    },
    watch: {
        '$i18n.locale'(newLocale) {
            localStorage.setItem('locale', newLocale);
        }
    },
}).$mount('#app')

if (localStorage.getItem('locale')) {
    i18n.locale = localStorage.getItem('locale');
}
